var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { ReservationForChartForVendorDto } from '../../../classes/reservation/response/reservation-for-chart-for-vendor.dto';
import { VehicleWithReservationForVendorDto } from '../../../classes/vehicle/response/vehicle-with-reservation-for-vendor.dto';
export class VehicleModelWithReservationForVendorDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.name = initializer.name;
        this.graphOrder = initializer.graphOrder;
        this.type = initializer.type;
        this.state = initializer.state;
        this.manufacturer = initializer.manufacturer;
        this.fuel = initializer.fuel;
        this.transmission = initializer.transmission;
        this.seat = initializer.seat;
        this.capacity = initializer.capacity;
        this.mileage = initializer.mileage;
        this.drivingSystem = initializer.drivingSystem;
        this.driverAge = initializer.driverAge;
        this.driverExperience = initializer.driverExperience;
        this.memo = initializer.memo;
        this.vehicles = initializer.vehicles;
        this.nonVehicleReservations = initializer.nonVehicleReservations;
    }
}
__decorate([
    Type(() => VehicleWithReservationForVendorDto),
    __metadata("design:type", Array)
], VehicleModelWithReservationForVendorDto.prototype, "vehicles", void 0);
__decorate([
    Type(() => ReservationForChartForVendorDto),
    __metadata("design:type", Array)
], VehicleModelWithReservationForVendorDto.prototype, "nonVehicleReservations", void 0);
